import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"

import Layout from "../components/layout"

class About extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const specialClass = 'simple-page'

    return (
      <Layout location={this.props.location} title={siteTitle} specialClass={specialClass}>
        <SEO
          title='Credits'
          description='Credits'
        />
        <section className="hidden"></section>
        <section>
          <div className="page-section container">
            <div className="page-content">
              <h1>Credits</h1>
              <p>
                Music in the video credited to <a href="https://www.bensound.com/">Bensound.com</a>
              </p>
              <p>
                Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
              </p>
              <br/>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default About

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
